<template>
  <a-modal
    title="报名费用说明"
    :visible="visible"
    :destroyOnClose="true"
    okText="提交"
    cancelText="取消"
    @cancel="handleCancel">
    <a-spin :spinning="loading">
      <div v-if="data != null">
        <span v-if="data.payModel === 'FREE'">
          <a-empty
            :image="freeImg"
            description="该赛事免报名费"
            :image-style="{ height: '60px'}"/>
        </span>
        <span v-if="data.payModel === 'PEOPLECHARGE'">
          <div>收费模式：{{ getPayType() }}</div>
          <div>首项费用：￥{{ data.threshold }}元</div>
          <div>加项费用：￥{{ data.addition }}元/项</div>
        </span>
        <span v-if="data.payModel === 'COMBOCHARGE'">
          <div>收费模式：{{ getPayType() }}</div>
          <div style="margin-top: 5px;">
            单项费用：
            <a-tag color="cyan" v-for="item in data.sigle" :key="item.combatName">{{ item.combatName }}{{'￥' + item.money}}元</a-tag>
          </div>
          <div style="margin-top: 5px;">
            套餐费用：
            <a-tag color="blue" v-for="item in data.tc" :key="item.combatName">{{ item.combatName }}{{'￥' + item.money}}元</a-tag>
          </div>
        </span>
        <span v-if="data.payModel === 'TEAMCHARGE'">
          <div>收费模式：{{ getPayType() }}</div>
          <div>收费标准：￥{{ data.teamAmount }}元/队</div>
        </span>
      </div>
    </a-spin>
  </a-modal>
</template>
<script>
export default {
  data () {
    return {
      loading: false,
      visible: false,
      freeImg: require('@comm/assets/join/free_amount.png'),
      data: null
    }
  },
  methods: {
    show () {
      this.visible = true
      this.queryPayModelData()
    },
    handleCancel () {
      this.visible = false
    },
    queryPayModelData () {
      this.loading = true
      this.$api.join.queryPayModelData(this.$route.query.matchId).then(res => {
        if (res.status === 0) {
          this.data = res.data
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        console.log(err)
        this.$message.error('获取数据失败')
      }).finally(_ => {
        this.loading = false
      })
    },
    getPayType () {
      switch (this.data.payModel) {
        case 'FREE':
          return '免报名费'
        case 'PEOPLECHARGE':
          return '按首项 + 加项收费'
        case 'COMBOCHARGE':
          return '按项目组合收费'
        case 'TEAMCHARGE':
          return '按队伍收费'
        default:
          return '未知'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/comm/components/join/pay/SignupPayModelData.vue